import Blog1Img from "./Images/how-to-find-verified-aviation-jobs-in-india-2025-guide.jpeg";
import Blog2Img from "./Images/why-bright-airways-is-a-trusted-name-in-aviation-training-and-job-placement-in-india.jpeg";
import Blog3Img from "./Images/v2-why-bright-airways-is-the-future-of-aviation-careers.jpeg";
import Blog4Img from "./Images/why-bright-airways-is-the-future-of-aviation-careers.png";
import Blog5Img from "./Images/banner 01.png";
import Blog6Img from "./Images/fakejob_banner.jpeg";
import Blog7Img from "./Images/after12thmaine.jpeg";

export const blogs = [
  {
    _id: "7",
    title:
      "Career Opportunities After 12th in Aviation: A Complete Guide to Building a Successful Career with Bright Airways",
    cardTitle: "Career Opportunities After 12th in Aviation",
    date: "2026-07-04",
    image: Blog7Img,
    content:
      "Explore the best aviation career opportunities after 12th, including cabin crew, ground staff, airport operations, hospitality, required skills, and future growth with Bright Airways guidance.",
    link: "/blog/career-opportunities-after-12th-in-aviation-a-complete-guide-to-building-a-successful-career-with-bright-airways",
  },
  {
    _id: "6",
    title:
      "10 Signs of Fake Airline Job Offers: How to Protect Yourself from Recruitment Scams",
    cardTitle: "10 Signs of Fake Airline Job Offers",
    date: "2026-07-04",
    image: Blog6Img,
    content:
      "Learn the 10 biggest warning signs of fake airline job offers and how to verify genuine aviation recruitment opportunities before sharing money or personal details.",
    link: "/blog/10-signs-of-fake-airline-job-offers-how-to-protect-yourself-from-recruitment-scams",
  },
  {
    _id: "5",
    title: "How to Start a Career in Aviation in India",
    date: "2026-06-18",
    image: Blog5Img,
    content:
      "A complete guide to starting your aviation career in India — roles, eligibility, training, salaries, and tips to get hired.",
    link: "/blog/how-to-start-a-career-in-aviation-in-india",
  },
  {
    _id: "1",
    title: "How to Find Verified Aviation Jobs in India (2025 Guide)",
    date: "2025-04-04",
    image: Blog1Img,
    content:
      "Learn how to spot verified aviation jobs in India and avoid fake offers with this step-by-step 2025 guide.",
    link: "/blog/how-to-find-verified-aviation-jobs-in-india-2025-guide",
  },
  {
    _id: "2",
    title:
      "Why Bright Airways is a Trusted Name in Aviation Training and Job Placement in India",
    date: "2025-09-24",
    image: Blog2Img,
    content:
      "why-bright-airways-is-a-trusted-name-in-aviation-training-and-job-placement-in-india",
    link: "/blog/why-bright-airways-is-a-trusted-name-in-aviation-training-and-job-placement-in-india",
  },
  {
    _id: "3",
    title: "Why Bright Airways is the Future of Aviation Careers",
    date: "2025-06-10",
    image: Blog3Img,
    content: "Why Bright Airways is the Future of Aviation Careers",
    link: "/blog/why-bright-airways-is-the-future-of-aviation-careers",
  },
  {
    _id: "4",
    title: "Is Bright Airways Real or Fake?",
    date: "2025-12-21",
    image: Blog4Img,
    content: "Is Bright Airways Real or Fake?",
    link: "/blog/is-bright-airways-real-or-fake",
  },

];
